import React from "react";
import classes from "../FitnessPreview.module.scss";

const ClockIconSvg = () => {
    return (<svg className={classes.clockIcon} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 12.5C22 18.02 17.52 22.5 12 22.5C6.48 22.5 2 18.02 2 12.5C2 6.98 6.48 2.5 12 2.5C17.52 2.5 22 6.98 22 12.5Z" stroke="#062021" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.7109 15.6798L12.6109 13.8298C12.0709 13.5098 11.6309 12.7398 11.6309 12.1098V8.00977" stroke="#062021" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    )
}

export default ClockIconSvg;